import { useMemo } from 'react';

import { ALL_PRODUCTS } from ':cloud/content/products';
import { useIsOnParticipateAllowlist } from ':cloud/hooks/featureFlags/useIsOnParticipateAllowlist';
import { useIsOnStakingAllowlist } from ':cloud/hooks/featureFlags/useIsOnStakingAllowlist';
import { useIsOnWaasConsumerAllowlist } from ':cloud/hooks/featureFlags/useIsOnWaasConsumerAllowlist';

export function useAllAvailableProducts() {
  const isOnStakingApiAllowlist = useIsOnStakingAllowlist();
  const isOnParticipateAllowlist = useIsOnParticipateAllowlist();
  const isOnWaasConsumerAllowlist = useIsOnWaasConsumerAllowlist();

  return useMemo(() => {
    return ALL_PRODUCTS.filter((product) => {
      if (
        (product.productType === 'staking_api' && !isOnStakingApiAllowlist) ||
        (product.productType === 'participate' && !isOnParticipateAllowlist) ||
        (product.productType === 'waas' && isOnWaasConsumerAllowlist) ||
        (product.productType === 'waas_consumer' && !isOnWaasConsumerAllowlist)
      ) {
        return false;
      }
      return true;
    });
  }, [isOnParticipateAllowlist, isOnStakingApiAllowlist, isOnWaasConsumerAllowlist]);
}
